import {StyleSheet} from "aphrodite";

import {addStyle} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";
import {LabelLarge} from "@khanacademy/wonder-blocks-typography";
import {FormattedText} from "@khan/guide-ui";

import type {JsonPath, MaybePlaceholder} from "../../types.ts";
import {isPlaceholder} from "../../utils.ts";
import EditableItem from "../editable-item.tsx";
import PlaceholderBlock from "../placeholder-block.tsx";

import AnswerNode from "./answer-node.tsx";
import type {QuestionData} from "./types.ts";

const StyledOl = addStyle("ol");
const StyledLi = addStyle("li");

interface Props {
    question: MaybePlaceholder<QuestionData>;
    path: JsonPath;
}

export default function QuestionNode({question, path}: Props) {
    if (isPlaceholder(question)) {
        return (
            <StyledLi>
                <PlaceholderBlock placeholderKey={question.$placeholder} />
            </StyledLi>
        );
    }

    const {questionText, answers} = question;

    return (
        <EditableItem path={path} tag={StyledLi}>
            <LabelLarge>
                <FormattedText text={questionText} />
            </LabelLarge>
            {answers.length > 1 && (
                <StyledOl style={styles.answerList}>
                    {answers.map((answer, i) => (
                        <AnswerNode
                            key={i}
                            answer={answer}
                            path={[...path, "answers", `${i}`]}
                        />
                    ))}
                </StyledOl>
            )}
        </EditableItem>
    );
}

const styles = StyleSheet.create({
    answerList: {
        listStyleType: "upper-alpha",
        marginBlockStart: sizing.size_160,
        paddingInlineStart: sizing.size_240,
        display: "flex",
        flexDirection: "column",
        gap: sizing.size_080,
    },
});
